export default {

	async init () {

		// Initialize the REST client interface
		Anvil.REST = new Anvil.models.rest.Client('central.webdisk.hu', 443)

		// ROUTING ------

		// Auth
		Anvil.route_map.set('login', 'auth/page_login')
		Anvil.route_map.set('register', 'auth/page_register')
		Anvil.route_map.set('forgotten-password', 'auth/page_forgotten_password')
		Anvil.route_map.set('password-reset', 'auth/page_password_reset')

		// Dashboard
		Anvil.route_map.set('home', 'main/page_home')
	}
}
